import {
  IPipelineMeasures,
  IPipelineYearAggregate,
  IPipelineYearMonthCell,
  PipelineStageGroupEnum,
} from '@/bundles/Pipeline/types';

export default class PipelineYearAggregateModel implements IPipelineYearAggregate {
  year: number;
  deal_count: number;
  measures: IPipelineMeasures;
  weighted_gross_pct: number;
  months: IPipelineYearMonthCell[];

  constructor (payload: IPipelineYearAggregate) {
    this.year = payload.year;
    this.deal_count = payload.deal_count;
    this.measures = payload.measures;
    this.weighted_gross_pct = payload.weighted_gross_pct;
    this.months = payload.months;
  }

  private sortedMonths (): IPipelineYearMonthCell[] {
    return this.months.slice().sort((first, second) => first.month - second.month);
  }

  monthlySeries (): Partial<Record<PipelineStageGroupEnum, number[]>> {
    const months = this.sortedMonths();
    const series: Partial<Record<PipelineStageGroupEnum, number[]>> = {};

    for (const group of Object.values(PipelineStageGroupEnum)) {
      series[group] = months.map(month => month.by_stage_group[group]);
    }

    return series;
  }

  monthlyDealCounts (): number[] {
    return this.sortedMonths().map(month => month.deal_count);
  }

  monthlyAgentGross (): number[] {
    return this.sortedMonths().map(month => month.measures.agent_gross);
  }
}
